<template lang="pug">
	div.cell(:style="style", @click="clickHandler")
</template>

<script>
	import logger from '~/modules/logger';
	import { negate } from '~/modules/cell-mutators';

	export default {
		name: 'Cell',
		props: {
			id: {
				type: Number,
				required: true
			}
		},
		computed: {
			cells () { return this.$store.state.cells; },
			color () { return this.cells[this.id]; },
			gridHeight () { return this.$store.state.height; },
			gridWidth () { return this.$store.state.width; },
			style () {
				return {
					'background-color': this.color.rgb().string(),
					'flex-basis': `${100 / this.gridWidth}vw`,
					height: `${100 / this.gridHeight}vh`,
					transition: `background-color ${this.$store.state.transitionDuration}ms linear`
				};
			}
		},
		methods: {
			clickHandler () {
				logger.info(`Clicked cell ${this.id}`);

				this.$store.commit('mutateCell', { index: this.id, mutator: negate });
			}
		}
	};
</script>

<style lang="scss" scoped>
	div.cell {
		flex-grow: 1;
		will-change: background-color;
		cursor: pointer;

		span.color-label { background-color: #fff; }
	}
</style>
